import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ToggleInput = ({ value, disabled, isScorecard, isHomepageActive, onChange }) => {
  const [currentValue, setCurrentValue] = useState(value)

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  const handleChange = () => {
    if (!disabled) {
      const newValue = !currentValue
      setCurrentValue(newValue)
      onChange(newValue)
    }
  }

  return (
    <div
      className={classNames('toggle-input', { active: currentValue })}
      value={currentValue}
      onClick={handleChange}
    >
      <div className='toggler-hover'></div>
      <div className={classNames('toggler-inner', { 'scorecard-toggler-inner': isScorecard && !isHomepageActive }, { 'scorecard-toggler-inner--active': isScorecard && isHomepageActive })}>
        <div className='toggler'></div>
      </div>
    </div>
  )
}

ToggleInput.propTypes = {
  value: PropTypes.any,
  disabled: PropTypes.bool,
  isScorecard: PropTypes.bool,
  isHomepageActive: PropTypes.bool,
  onChange: PropTypes.func
}

ToggleInput.defaultProps = {
  value: false,
  disabled: false,
  isScorecard: false,
  isHomepageActive: false,
  onChange: (e) => {} // This is intentional
}

export default ToggleInput
